import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { JandiLogoWhite } from "@/components/assets/logos/svgs"; // Adjust import path as needed

const Footer = ({ onOpenRegister }) => {
  const { t, i18n } = useTranslation();
  /** Keeps footer in sync when `switchLanguage` runs (same path as `i18n.changeLanguage`). */
  const languageFromStore = useSelector((state) => state.language);
  const [ready, setReady] = useState(() => i18n.isInitialized);
  const [isPhonePopupOpen, setIsPhonePopupOpen] = useState(false);
  const phoneNumber = "787-436-6326";
  const phoneNumberLabel = t("footer_phoneLabel", { phone: phoneNumber });

  useEffect(() => {
    if (i18n.isInitialized) {
      setReady(true);
    } else {
      const handleInit = () => setReady(true);
      i18n.on("initialized", handleInit);
      return () => {
        i18n.off("initialized", handleInit);
      };
    }
  }, [i18n]);

  if (!ready) return null;

  return (
    <footer
      key={languageFromStore}
      className="main-footer"
      style={{
        background: "var(--primary-color)",
        padding: "2rem 0",
        color: "white",
        fontSize: "14px",
        fontFamily: '"Object Sans", system-ui, sans-serif',
      }}
    >
      <div className="container mx-auto px-4 xl:px-6 2xl:px-8 max-w-[1800px]">
        {isPhonePopupOpen ? (
          <div
            role="dialog"
            aria-modal="true"
            aria-label="Phone number"
            onClick={() => setIsPhonePopupOpen(false)}
            style={{
              position: "fixed",
              inset: 0,
              background: "rgba(0,0,0,0.45)",
              zIndex: 9999,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "16px",
            }}
          >
            <div
              onClick={(e) => e.stopPropagation()}
              style={{
                width: "min(520px, 100%)",
                background: "#fff",
                borderRadius: "14px",
                padding: "18px",
                color: "#111",
                boxShadow: "0 20px 60px rgba(0,0,0,0.25)",
                fontFamily: '"Object Sans", system-ui, sans-serif',
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: "12px",
                  marginBottom: "10px",
                }}
              >
                <div style={{ fontWeight: 700, fontSize: "16px" }}>
                  {phoneNumberLabel}
                </div>
                <button
                  type="button"
                  onClick={() => setIsPhonePopupOpen(false)}
                  style={{
                    border: "none",
                    background: "transparent",
                    cursor: "pointer",
                    fontSize: "20px",
                    lineHeight: 1,
                    color: "#666",
                  }}
                  aria-label="Close"
                >
                  ×
                </button>
              </div>

              <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
                <a
                  href={`tel:${phoneNumber}`}
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "10px 14px",
                    borderRadius: "10px",
                    background: "var(--primary-color)",
                    color: "#fff",
                    fontWeight: 700,
                    textDecoration: "none",
                  }}
                >
                  {t("footer_call")}
                </a>
                <button
                  type="button"
                  onClick={async () => {
                    try {
                      await navigator.clipboard.writeText(phoneNumber);
                    } finally {
                      setIsPhonePopupOpen(false);
                    }
                  }}
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "10px 14px",
                    borderRadius: "10px",
                    background: "#EEF2FF",
                    color: "#111",
                    fontWeight: 700,
                    border: "1px solid #E5E7EB",
                    cursor: "pointer",
                  }}
                >
                  {t("footer_copy")}
                </button>
              </div>
            </div>
          </div>
        ) : null}

        {/* Desktop Layout */}
        <div className="desktop-footer">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 items-start md:pl-4 xl:pl-6">
            {/* Jandi Logo Section */}
            <div className="footer-section">
              <div className="logo me-4" style={{ marginBottom: "1rem" }}>
                <Link to="/">
                  <JandiLogoWhite className="w-[125px]" />
                </Link>
                {/* Siempre a la mano (left) */}
                <p
                  className="desktop-only"
                  style={{
                    margin: 0,
                    gridColumn: "1 / 2",
                    color: "white",
                    opacity: 0.55,
                    fontStyle: "italic",
                  }}
                >
                  {t("alwaysAtHand") || "Siempre a la mano."}
                </p>
              </div>
            </div>

            {/* Discover Jandi Section */}
            <div className="footer-section">
              <h4
                style={{
                  color: "white",
                  opacity: 0.5,
                  marginBottom: "1rem",
                  fontSize: "10px",
                  fontWeight: "500",
                  letterSpacing: "0.1em",
                  textTransform: "uppercase",
                  fontFamily: '"Object Sans", system-ui, sans-serif',
                }}
              >
                {t("discoverJandi")}
              </h4>
              <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                {/* <li style={{}}>
                  <Link
                    to="/registro/worker"
                    style={{
                      color: "white",
                      textDecoration: "none",
                      fontWeight: "500",
                      display: "block",
                      textAlign: "left",
                      opacity: 0.8,
                      fontSize: "13px",
                    }}
                  >
                    {t("iWantToOfferMyServices")}
                  </Link>
                </li> */}
                <li style={{}}>
                  <a
                    href="/servicios"
                    style={{
                      color: "white",
                      textDecoration: "none",
                      fontWeight: "500",
                      display: "block",
                      opacity: 0.8,
                      fontSize: "13px",
                    }}
                  >
                    {t("services")}
                  </a>
                </li>
                <li>
                  <Link
                    to="/sobre-nosotros"
                    style={{
                      color: "white",
                      textDecoration: "none",
                      fontWeight: "500",
                      display: "block",
                      textAlign: "left",
                      opacity: 0.8,
                      fontSize: "13px",
                    }}
                  >
                    {t("whatMovesUs")}
                  </Link>
                </li>
                <li>
                  <Link
                    to="/registro"
                    style={{
                      color: "white",
                      textDecoration: "none",
                      fontWeight: "500",
                      display: "block",
                      textAlign: "left",
                      opacity: 0.8,
                      fontSize: "13px",
                    }}
                  >
                    {t("register")}
                  </Link>
                </li>
                <li>
                  <Link
                    to="/preguntas-frecuentes"
                    style={{
                      color: "white",
                      textDecoration: "none",
                      fontWeight: "500",
                      display: "block",
                      textAlign: "left",
                      opacity: 0.8,
                      fontSize: "13px",
                    }}
                  >
                    {t("frequentlyAskedQuestions")}
                  </Link>
                </li>
              </ul>
            </div>

            {/* Legal Agreements Section */}
            <div className="footer-section">
              <h4
                style={{
                  color: "white",
                  opacity: 0.5,
                  marginBottom: "1rem",
                  fontSize: "10px",
                  fontWeight: "500",
                  letterSpacing: "0.1em",
                  textTransform: "uppercase",
                  fontFamily: '"Object Sans", system-ui, sans-serif',
                }}
              >
                {t("legalAgreements")}
              </h4>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <Link
                  to="/politica-de-privacidad"
                  style={{
                    color: "white",
                    textDecoration: "none",
                    fontWeight: "500",
                    display: "block",
                    opacity: 0.8,
                    fontSize: "13px",
                  }}
                >
                  {t("privacyPolicy")}
                </Link>
                <Link
                  to="/terminos-de-uso"
                  style={{
                    color: "white",
                    textDecoration: "none",
                    fontWeight: "500",
                    display: "block",
                    opacity: 0.8,
                    fontSize: "13px",
                  }}
                >
                  {t("termOfUse")}
                </Link>
                <Link
                  to="/politica-de-mensajes"
                  style={{
                    color: "white",
                    textDecoration: "none",
                    fontWeight: "500",
                    display: "block",
                    opacity: 0.8,
                    fontSize: "13px",
                  }}
                >
                  {t("textMessagePolicy")}
                </Link>
              </div>
            </div>

            {/* Social Media Section */}
            <div className="footer-section">
              <h4
                style={{
                  color: "white",
                  opacity: 0.5,
                  marginBottom: "1rem",
                  fontSize: "10px",
                  fontWeight: "500",
                  letterSpacing: "0.1em",
                  textTransform: "uppercase",
                  fontFamily: '"Object Sans", system-ui, sans-serif',
                }}
              >
                {t("alwaysAtHand")}
              </h4>
              <div style={{ marginBottom: "1.5rem" }}>
                <div style={{
                  display: "flex",
                  gap: "0.8rem",
                  alignItems: "center"
                }}>
                  {/* Social Icons - Same as before */}
                  <a href="https://www.instagram.com/holasoyjandi?stkn=MTNqdHg3YzIwMXRhdQ==" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
                    <div style={{ width: "35px", height: "35px", borderRadius: "50%", overflow: "hidden", border: "2px solid white", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", transition: "opacity 0.2s ease" }}>
                      {/* <img src="IG.png" alt="Instagram" /> */}
                      <p className="text-white text-sm h-4">IG</p>
                    </div>
                  </a>
                  <a href="https://facebook.com/jandi.pr_" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
                    <div style={{ width: "35px", height: "35px", borderRadius: "50%", overflow: "hidden", border: "2px solid white", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", transition: "opacity 0.2s ease" }}>
                      {/* <img src="/FB.png" alt="Facebook" /> */}
                      <p className="text-white text-sm h-4">FB</p>
                    </div>
                  </a>
                  <a href="mailto:hola@jandipr.com" style={{ textDecoration: 'none' }}>
                    <div style={{ width: "35px", height: "35px", borderRadius: "50%", overflow: "hidden", border: "2px solid white", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", transition: "opacity 0.2s ease" }}>
                      {/* <img src="/E.png" alt="Email" /> */}
                      <p className="text-white text-sm h-4">E</p>
                    </div>
                  </a>
                  <a
                    href="tel:787-436-6326"
                    onClick={(e) => {
                      e.preventDefault();
                      setIsPhonePopupOpen(true);
                    }}
                    style={{
                      textDecoration: "none",
                      display: "inline-flex",
                      alignItems: "center",
                      gap: "0.6rem",
                      color: "white",
                    }}
                  >
                    <div style={{ width: "35px", height: "35px", borderRadius: "50%", overflow: "hidden", border: "2px solid white", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", transition: "opacity 0.2s ease" }}>
                      <p className="text-white text-sm h-4">PH</p>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Mobile Layout */}
        {/* Mobile Layout */}
        <div className="mobile-footer">
          {/* All sections in vertical layout - Left aligned */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '2rem', textAlign: 'left', paddingLeft: '20px' }}>

            {/* Logo and Text Section - Now beneath social icons */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
              <Link to="/">
                <JandiLogoWhite className="w-[110px]" />
              </Link>
              <p style={{ margin: 0, color: "white", fontSize: "0.9rem" }}>
                {t("alwaysAtHand") || "Siempre a la mano."}
              </p>
            </div>

            {/* Discover Jandi Section */}
            <div className="footer-section">
              <h4
                style={{
                  color: "white",
                  opacity: 0.5,
                  marginBottom: "1rem",
                  fontSize: "10px",
                  fontWeight: "500",
                  letterSpacing: "0.1em",
                  textTransform: "uppercase",
                  fontFamily: '"Object Sans", system-ui, sans-serif',
                }}
              >
                {t("discoverJandi")}
              </h4>
              <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
              <li style={{}}>
                  <a
                    href="/servicios"
                    style={{
                      color: "white",
                      textDecoration: "none",
                      fontWeight: "500",
                      display: "block",
                      textAlign: "left",
                      opacity: 0.8,
                      fontSize: "13px",
                    }}
                  >
                    {t("services")}
                  </a>
                </li>
                <li>
                  <Link
                    to="/sobre-nosotros"
                    style={{
                      color: "white",
                      textDecoration: "none",
                      fontWeight: "500",
                      display: "block",
                      textAlign: "left",
                      opacity: 0.8,
                      fontSize: "13px",
                    }}
                  >
                    {t("whatMovesUs")}
                  </Link>
                </li>
                <li>
                  <Link
                    to="/registro"
                    style={{
                      color: "white",
                      textDecoration: "none",
                      fontWeight: "500",
                      display: "block",
                      textAlign: "left",
                      opacity: 0.8,
                      fontSize: "13px",
                    }}
                  >
                    {t("register")}
                  </Link>
                </li>
                <li>
                  <Link
                    to="/preguntas-frecuentes"
                    style={{
                      color: "white",
                      textDecoration: "none",
                      fontWeight: "500",
                      display: "block",
                      textAlign: "left",
                      opacity: 0.8,
                      fontSize: "13px",
                    }}
                  >
                    {t("frequentlyAskedQuestions")}
                  </Link>
                </li>
              </ul>
            </div>

            {/* Legal Agreements Section */}
            <div className="footer-section">
              <h4
                style={{
                  color: "white",
                  opacity: 0.5,
                  marginBottom: "1rem",
                  fontSize: "10px",
                  fontWeight: "500",
                  letterSpacing: "0.1em",
                  textTransform: "uppercase",
                  fontFamily: '"Object Sans", system-ui, sans-serif',
                }}
              >
                {t("legalAgreements")}
              </h4>
              <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
                <Link
                  to="/politica-de-privacidad"
                  style={{
                    color: "white",
                    textDecoration: "none",
                    fontWeight: "500",
                    display: "block",
                    textAlign: "left",
                    opacity: 0.8,
                    fontSize: "13px",
                  }}
                >
                  {t("privacyPolicy")}
                </Link>
                <Link
                  to="/terminos-de-uso"
                  style={{
                    color: "white",
                    textDecoration: "none",
                    fontWeight: "500",
                    display: "block",
                    textAlign: "left",
                    opacity: 0.8,
                    fontSize: "13px",
                  }}
                >
                  {t("termOfUse")}
                </Link>
                <Link
                  to="/politica-de-mensajes"
                  style={{
                    color: "white",
                    textDecoration: "none",
                    fontWeight: "500",
                    display: "block",
                    textAlign: "left",
                    opacity: 0.8,
                    fontSize: "13px",
                  }}
                >
                  {t("textMessagePolicy")}
                </Link>
              </div>
            </div>

            {/* Social Media Section */}
            <div className="footer-section">
              <h4
                style={{
                  color: "white",
                  opacity: 0.5,
                  marginBottom: "1rem",
                  fontSize: "10px",
                  fontWeight: "500",
                  letterSpacing: "0.1em",
                  textTransform: "uppercase",
                  fontFamily: '"Object Sans", system-ui, sans-serif',
                }}
              >
                {t("alwaysAtHand")}
              </h4>
              <div style={{ marginBottom: "1.5rem" }}>
                <div style={{
                  display: "flex",
                  gap: "0.8rem",
                  alignItems: "center"
                }}>
                  {/* Social Icons */}
                  <a href="https://www.instagram.com/holasoyjandi?stkn=MTNqdHg3YzIwMXRhdQ==" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
                    <div style={{ width: "35px", height: "35px", borderRadius: "50%", overflow: "hidden", border: "2px solid white", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", transition: "opacity 0.2s ease" }}>
                    <p className="text-white text-sm h-4">IG</p>
                    </div>
                  </a>
                  <a href="https://www.facebook.com/share/16SSRydPNR/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
                    <div style={{ width: "35px", height: "35px", borderRadius: "50%", overflow: "hidden", border: "2px solid white", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", transition: "opacity 0.2s ease" }}>
                    <p className="text-white text-sm h-4">FB</p>
                    </div>
                  </a>
                  <a href="mailto:hola@jandipr.com" style={{ textDecoration: 'none' }}>
                    <div style={{ width: "35px", height: "35px", borderRadius: "50%", overflow: "hidden", border: "2px solid white", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", transition: "opacity 0.2s ease" }}>
                    <p className="text-white text-sm h-4">E</p>
                    </div>
                  </a>
                  <a
                    href="tel:787-436-6326"
                    onClick={(e) => {
                      e.preventDefault();
                      setIsPhonePopupOpen(true);
                    }}
                    style={{
                      textDecoration: "none",
                      display: "inline-flex",
                      alignItems: "center",
                      gap: "0.6rem",
                      color: "white",
                    }}
                  >
                    <div style={{ width: "35px", height: "35px", borderRadius: "50%", overflow: "hidden", border: "2px solid white", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", transition: "opacity 0.2s ease" }}>
                      <p className="text-white text-sm h-4">PH</p>
                    </div>
                  </a>
                </div>
              </div>
            </div>


          </div>
        </div>

        {/* Copyright */}
        <div
          className="copyright-section"
          style={{
            marginTop: "1rem",
            // paddingTop: "1rem",
            fontSize: "0.8rem",
            color: "white",
            position: "relative",
          }}
        >
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(4, 1fr)",
              alignItems: "center",
              maxWidth: "100%",
              margin: "0 auto",
              padding: "0 1rem",
              position: "relative",
              borderTop: "1px solid rgba(255, 255, 255, 0.15)",
            }}
          >
            {/* Copyright under Discover Jandi (2nd column) */}
            <p
              className="copyright-right"
              style={{
                margin: 0,
                color: "white",
                opacity: 0.55,
                fontSize: "11px",
                gridColumn: "2 / 3",
              }}
            >
              © {new Date().getFullYear()} {t("copyright")}
            </p>
          </div>
        </div>

      </div>

      <style>{`
  @media (max-width: 768px) {
    .desktop-footer {
      display: none !important;
    }
    .mobile-footer {
      display: block !important;
    }
    .desktop-only {
      display: none !important;
    }
    .copyright-section {
      justify-content: flex-start !important;
      padding-left: 10px !important;
    }
  }
  @media (min-width: 769px) {
    .mobile-footer {
      display: none !important;
    }
    .copyright-left{
      margin-left: 9px !important;
    }
    .copyright-right {
      margin-left: 16px !important;
    }
  }

  @media (max-width: 768px) {
  .copyright-section > div {
    display: flex !important;
    flex-direction: column !important;
    align-items: flex-start !important;
    padding-left: 10px !important;
    gap: 0.5rem;
  }
}

`}</style>
    </footer>
  );
};

export default Footer;